import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';   // ✅ Import Capacitor directly

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    // Remove splash screen overlay after Angular loads
    document.body.classList.remove('splash-active');

    // ✅ Register Service Worker only in production & only when NOT running inside Capacitor
    if (environment.production && !Capacitor.isNativePlatform()) {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('ngsw-worker.js')
          .then(registration => {
          })
          .catch(error => {
          });
      }
    }
  })
  .catch(err => console.error(err));
